import api from "./api";

const communicationService = {
  getAll: (params) => api.get("/communications", { params }),
  getById: (id) => api.get(`/communications/${id}`),
  create: (data) => api.post("/communications", data),
  delete: (id) => api.delete(`/communications/${id}`),
  markAsRead: (id) => api.post(`/communications/${id}/read`),
  getUnreadCount: () => api.get("/communications/unread-count"),
  uploadAttachment: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/communications/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export default communicationService;
